import React, { Component } from 'react'

class AjaxSpinner extends Component {
  render() {
    return (
      <div className='spinner ajax'>
        <div className='circle'></div>
      </div>
    )
  }
}

export default AjaxSpinner



// WEBPACK FOOTER //
// ./src/components/AjaxSpinner.js